import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ca-file-download-btn',
    templateUrl: './file-download-btn.component.html',
    styleUrls: ['./file-download-btn.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileDownloadBtnComponent {
    @ViewChild('buttonRef') buttonRef: ElementRef;
    @Input() title = '';
    @Input() isBusy: boolean;
    @Input() disabled: boolean = false;
    @Input() isBusyIcon = 'download';
    @Input() description: string;
    @Input() isTrainPage: boolean = false;
    @Input() isSegmentationDetailPage: boolean = false;

    @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

    onClickBtn(): void {
        this.onClick.emit();
        this.buttonRef.nativeElement.blur();
    }
}
